export default __webpack_public_path__ + "static/media/floorplan.ba77d340.png";